






























































































import {
  Row,
  Col,
  Swipe,
  SwipeItem,
  Toast,
  Dialog,
  Popup as vanPopup,
  Image as vanImage
} from "vant";
import Base from "@/template/public/Base.vue";
import { Component, Vue } from "vue-property-decorator";
import { wxChatShare } from "@/common/wechat";
import request from "@/api/wanzhou";
import Openapp from "@/components/openApp.vue";
import native from "@/common/Native";
import { IShareInfo } from "@/api/types";
import AppPrompt from "@/components/AppPrompt.vue";
import Poster from "@/components/Poster.vue";
import { getData, time } from "@/common/dataCollect";
@Component({
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    Openapp,
    vanImage,
    vanPopup,
    AppPrompt,
    Poster
  }
})
export default class NewsMultiple extends Base {
  public request = new request();
  private imgList: Array<object> = [];
  private imgInfo: object | any = {};
  private id: string = "";
  infoClassifyId: string = "";
  private newsId: string = "";
  private appId: string = "";
  private current: string = "";
  private bg: string = "0.5";
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  vfrom: string = ""; //是否预览
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  shareInfo: any = {};
  //打赏
  isShowPraise: boolean = false;
  userScore: string | number = ""; // 用户积分
  sendScore: number | string = ""; // 打赏积分
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  created() {
    this.startTime = time();
  }
  mounted() {
    this.infoClassifyId = this.id = this.$route.query.id as string;
    this.appId = this.$route.query.appId as string;
    this.vfrom = (this.$route.query.vfrom as string) || "";
    console.log(this.appId);
    this.getImgList();
    this.getCount();
    //九龙坡 预览新闻时, 底部评论和顶部分享不显示
    if (this.vfrom && ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "",
        isShowMoreBtn: "0"
      });
      ZWY_CLOUD.bottomBarConfig({
        isShowBottom: 0,
        callBack_replyList: "releaseReplyList",
        praiseNum: 0,
        isPraised: 0
      });
    }
    if (ZWY_CLOUD.isOpenInApp()) {
      // get用户信息
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        this.getBussinessDetail();
      });
    } else {
      this.getBussinessDetail();
    }
  }
  onChange(index: string) {
    this.current = index;
  }
  // 获取多图列表
  getImgList() {
    return this.request.jyhNewsDetail(this.id).then(res => {
      if (res.code === 0) {
        this.imgInfo = res.data;
        console.log(res.data.viewCount);
        document.title = this.imgInfo.title;
        this.imgList = this.imgInfo.appResource;
        this.appId = this.imgInfo.appId;
        this.$store.commit("SET_STATE", {
          appId: this.appId
        });

        this.getShareInfo(this.imgInfo.appId);
        this.$nextTick(() => {
          // 埋点
          this.endTime = time();
          if (this.dataSource) {
            getData(this.startTime, this.endTime, this.imgInfo);
            this.dataSource = false;
          }
        });
      }
    });
  }
  // 浏览量
  getCount() {
    if (!native.isOpenInApp()) {
      // 在app外才需要增加浏览量
      this.request.getCount(this.appId, this.id);
    }
  }
  // 唤醒
  openApp() {
    this.newsId = this.id;
    const shareInfo = this.shareInfo as IShareInfo;
    if (!shareInfo.schemeUrl) {
      return (location.href = shareInfo.downloadUrl);
    }
    let schemeUrl = shareInfo.schemeUrl.split("/");
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      const Params = {
        id: this.newsId,
        sourceId: this.newsId,
        sourceType: "85",
        url: location.href,
        shareUrl: location.href
      };
      location.href = `${shareInfo.schemeUrl}/info/install/${this.appId}.html?id=${this.newsId}&&&sourceId=${this.newsId}&&&sourceType=1&&&url=${location.href}&&&shareUrl=`;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      const Params = {
        id: this.newsId,
        sourceId: this.newsId,
        sourceType: "85",
        url: location.href,
        shareUrl: location.href
      };
      // alert(JSON.stringify(Params));
      location.href = schemeUrl[2] + `://?params=${JSON.stringify(Params)}`;
      setTimeout(() => {
        location.href = shareInfo.downloadUrl;
      }, 3000);
    } else {
      location.href = shareInfo.downloadUrl;
    }
  }
  /**业务详情 */
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        // this.newsInfo.informationId,
        this.id,
        "85",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0) {
          this.businessDetail = response.data;
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            response.data.shareUrlWx,
            response.data.shareImgUrl
          );
        }
      });
  }

  // 打赏
  toPraise() {
    this.sendScore = "";
    if (native.isOpenInApp()) {
      native.goToken().then(res => {
        this.userInfo = res;

        if (this.userInfo && this.userInfo.token) {
          this.getQueryRemainderPoint();
          this.isShowPraise = true;
        }
      });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp();
      });
    }
  }
  // 获取积分详情 queryRemainderPoint
  getQueryRemainderPoint() {
    // 获取用户token
    Toast.loading({
      message: "数据请求中...",
      forbidClick: true
    });
    this.request
      .jyhQueryRemainderPoint({
        appId: this.appId,
        token: this.userInfo.token
      })
      .then((res: any) => {
        if (res.code >= 0) {
          this.userScore = res.data;
          console.log(this.userScore);
        } else {
          Toast.fail(res.message);
        }
      })
      .finally(() => {
        Toast.clear();
      });
  }
  confirmSendScore() {
    if (!this.sendScore && this.sendScore !== 0) {
      return Toast.fail("请输入打赏积分");
    }
    if (this.sendScore <= 0) {
      return Toast.fail("打赏积分不能小于等于0");
    }
    let userScore = Number(this.userScore);
    if (!isNaN(userScore)) {
      if (Number(this.sendScore) > userScore) {
        return Toast.fail("您打赏的金额已超过您的剩余积分，请重新输入");
      }

      Toast.loading({
        message: "打赏中...",
        forbidClick: true
      });
      this.request
        .jyhReward({
          appId: this.appId,
          token: this.userInfo.token,
          infoClassifyId: this.infoClassifyId,
          integral: this.sendScore,
          jyhId: this.imgInfo.jyhId
        })
        .then((res: any) => {
          if (res.code >= 0) {
            setTimeout(() => {
              Toast.success("打赏成功");
            }, 50);
            this.isShowPraise = false;
            this.sendScore = "";
          } else {
            setTimeout(() => {
              Toast.fail(res.message);
            }, 50);
          }
        })
        .finally(() => {
          Toast.clear();
        });
    }
  }
  sendScoreChange() {
    this.sendScore = Math.floor(Math.abs(Number(this.sendScore)));
  }
}
